module.exports = __webpack_public_path__ + "static/Cleverbridge-c09da0e2eaa6be115518228b2a6ffcf0.svg";